import React from 'react';
import { Typography } from '@shared/ui/typography/typography';
import { Link, Button } from '@vtbhome/juicyfront';
import { ROUTE_ADMIN_PRODUCT_BUY_ORDER_BASE } from '@shared/config/routes/routes';
import { ModalCommonDataProps } from './types';
import { BaseCell } from './modal-common-data.styles';
import { useCommonData, useBankDetails } from './common-data';
import { useRedirect } from '@shared/lib/hooks/use-redirect/use-redirect';
import { OrderStatus } from '@shared/model/order';

export const ModalCommonData: React.FC<ModalCommonDataProps> = ({
    orderData,
    orderId,
    showBankDetails,
    goToBuyOrderRoute,
}) => {
    const redirect = useRedirect();
    const commonData = useCommonData({ orderData });
    const bankDetails = useBankDetails({ orderData });

    const handleBuyOrderRoute = () => {
        redirect({ url: `${ROUTE_ADMIN_PRODUCT_BUY_ORDER_BASE}/${orderId}` });
    };

    return (
        <>
            <BaseCell key={orderData?.id} isFullWidth>
                <Typography color='neutral_50' size='body1_short'>
                    ID сделки
                </Typography>
                <Typography color='black' size='body1_long'>
                    {`№${orderData?.id}`}
                </Typography>
            </BaseCell>

            {commonData.map(({ label, content, id, isFullWidth }) => {
                return (
                    content && (
                        <BaseCell key={id} isFullWidth={isFullWidth}>
                            <Typography color='neutral_50' size='body1_short'>
                                {label}
                            </Typography>
                            <Typography color='black' size='body1_long'>
                                {content}
                            </Typography>
                        </BaseCell>
                    )
                );
            })}

            {showBankDetails &&
                bankDetails.map(({ label, content, id }) => {
                    return (
                        content && (
                            <BaseCell key={id}>
                                <Typography color='neutral_50' size='body1_short'>
                                    {label}
                                </Typography>
                                <Typography color='black' size='body1_long'>
                                    {content}
                                </Typography>
                            </BaseCell>
                        )
                    );
                })}

            {orderData?.product?.productInfoUrl && orderData.status === OrderStatus.Completed && (
                <BaseCell isFullWidth>
                    <Typography color='neutral_50' size='body1_short'>
                        Ссылка на продукт
                    </Typography>
                    <Link color='primary' size='md' href={orderData?.product?.productInfoUrl}>
                        {orderData?.product?.productInfoUrl}
                    </Link>
                </BaseCell>
            )}

            {goToBuyOrderRoute && (
                <Button buttonType='light' size='m' onClick={handleBuyOrderRoute}>
                    Перейти на страницу приобретения продукта
                </Button>
            )}
        </>
    );
};
